module.exports = __webpack_public_path__ + "static/Cooling_form_EN-710607da4705a9de87c45ea5b204f535.pdf";